'use strict';

import * as YPHost from 'bsl/constants/YPHost';
import { BusinessConfig } from 'bsl/constants/BusinessConfig';
import { NativeModules, Platform } from 'react-native';

const CommonBridgeModule = NativeModules.CommonBridgeModule;
const appKey = ((CommonBridgeModule && CommonBridgeModule.AppKey) || '').toLowerCase() || process.env.APPCHANNEL;

const isMiShop = appKey === 'mishop';
// app  env
const urlMap = {
  '1_0': 'https://m.mi.com',
  '1_1': 'https://m.test.mi.com',
  '1_2': 'https://pre.m.mi.com',
  '0_0': YPHost.M.tradeUrl,
  '0_1': YPHost.M.TradeStDomain,
  '0_2': YPHost.M.TradeStDomain,
};
const Constants = {
  AppName: '小米有品',

  UA_pixels: '1080x1920',

  UserId: '',
  PassToken: '',

  CurrentPage: '',

  isUseFragment: false,

  /**
   * 具体业务中，还是尽量使用Constants，降低外部对YPHost直接引用
   */
  Host: YPHost,
  StDomain: `${YPHost.M.StDomain}/`,
  TradeStDomain: `${YPHost.M.TradeStDomain}/`,
  UrlPrefix: `${YPHost.M.Url}/`,
  get tradeUrlPrefix() {
    if (Platform.OS === 'web') {
      return `${location.origin}/`;
    }
    const str = `${isMiShop ? 1 : 0}_${Constants.envMode}`;
    return `${urlMap[str] || YPHost.M.tradeUrl}/${isMiShop ? '' : 'tr/'}`;
  },

  DefaultUrl: `${YPHost.M.Url}/main?root=1`,
  AppDownloadUrl: `${YPHost.M.Url}/about`,

  // TODO. 未来所有RN页的/shop的将统一换成/r，运维用以区分端！！！
  UrlRNPrefix: `${YPHost.M.Url}/r/`,

  MiJiaHost: 'home.mi.com',
  MiJiaStaticHost: 'static.home.mi.com',
  YouPinHost: 'mijiayoupin.com',
  YouPinPCHost: 'youpin.mi.com',
  YouPinPCStaticHost: 'static.youpin.mi.com',

  // TODO: Just for save ios default user agent.
  KEY_IOS_UserAgent: 'ios_default_useragent',
  IOS_UserAgent: null,

  get MainSid() {
    return appKey === 'mishop' ? 'eshopmobile' : 'miotstore';
  },
  get MainDomain() {
    return appKey === 'mishop' ? '.retail.mi.com' : 'shopapi.io.mi.com';
  },
  ExtraServiceToken: {
    // mi_huodong: 'i.huodong.mi.com',
    // mi_eshopm_go: 'm.mi.com',
  },

  PasswordCenterUrl: 'https://account.xiaomi.com/pass/auth/security/home?_locale=zh_CN',

  FlashSaleUrl: 'https://m.xiaomiyoupin.com/r/secbuy?type=secbuy',

  // 通用消息Key
  EmitterKey: {
    ORDER_NEED_REFRESH: '_orderNeedRefreshAction',
  },

  /**
   * 自定义的错误码标识
   */
  ErrorTag: {
    // 加到后端返回的errorMsg中，区别前端还是后端的错误
    RN: '（：',
    Server: '：）',
  },

  /**
   * 从组件到URL地址
   */
  ComponentToPath: Object.freeze({}),

  BusinessConfig: BusinessConfig,
  envMode: 0,
  /**
   * 动态生成RN && M站 Map信息。目的：以后新增的页面，只需要配置：<path: Component>即可
   **（RN: path to Component（其中有含shop和不含shop两种），M站：Url to path（React-Router再根据path映射到Component））
   */
};

// console.log(Constants.UriPathMapComponent);

export default Constants;
